import { FC, useState } from "react";
import {
    ContentItem,
} from "./styled";
import { MainScreenFilter, TeamContext } from "../../../types/common";
import { MatchListMiniWidget } from "../../stats/match-list/MatchListMiniWidget";
import { TournamentTableMiniWidget } from "../../stats/tournament-table/TournamentTableMiniWidget";
import { getUrlByContext } from "../../../utils";
import { Tabs } from "antd";
import type { TabsProps } from 'antd';
import { PlayersStatsMiniWidget } from "../../stats/players/PlayersStatsMiniWidget";

interface MainScreenStatsWigdetProps {
    statsFilters?: MainScreenFilter[];
    topTeams?: number;
    bottomTeams?: number;
    prevMatches?: number;
    teamName?: TeamContext;
}

export const MainScreenStatsWigdet: FC<MainScreenStatsWigdetProps> = (
    { topTeams, bottomTeams, prevMatches, teamName, statsFilters }
) => {
    const [showPlayers, setShowPlayers] = useState(true);
    const statItems = statsFilters.map((filter, index) => {
        const { tournamentId, seasonId, teamId } = filter;
        const searchParams = new URLSearchParams();
        searchParams.set('turnir', tournamentId.toString());
        searchParams.set('sezon', seasonId.toString());
        return (
            <div key={`${tournamentId}-${seasonId}-${teamId}`} className="flex flex-col items-center w-full max-w-[1024px] mx-auto">
                <div className="flex flex-col items-start w-full sm:justify-between sm:flex-row gap-2">
                    <ContentItem>
                        <TournamentTableMiniWidget
                            tournamentId={tournamentId}
                            seasonId={seasonId}
                            teamId={teamId}
                            topTeams={topTeams}
                            bottomTeams={bottomTeams}
                            teamName={teamName}
                        />
                        {/*<div className="py-2"/>
                        <a href={getUrlByContext(`/games/tables/?${searchParams.toString()}`, teamName)} className="hidden sm:block transition-all cursor-pointer rounded-full text-sky-800 font-bold py-4 px-6 text-lg bg-slate-100 hover:bg-gray-100 active:scale-95 hover:text-sky-600 hover:shadow-sm hover:no-underline">Полная таблица</a>*/}
                    </ContentItem>
                    {!showPlayers && <ContentItem>
                        <MatchListMiniWidget
                            tournamentId={tournamentId}
                            seasonId={seasonId}
                            teamId={teamId}
                            prevMatches={prevMatches}
                            totalMatches={topTeams + bottomTeams + 1}
                            teamName={teamName}
                        />
                        {/*<div className="sm:py-2"/>
                        <div className="transition-all cursor-pointer rounded-full text-sky-800 font-bold py-4 px-6 text-lg bg-slate-100 hover:bg-gray-100 active:scale-95 hover:text-sky-600 hover:shadow-sm" onClick={() => setShowPlayers(true)}>Показать бомбардиров</div>*/}
                    </ContentItem>}
                    {showPlayers && <ContentItem>
                        <PlayersStatsMiniWidget
                            tournamentId={tournamentId}
                            seasonId={seasonId}
                            teamId={teamId}
                            totalPlayers={topTeams + bottomTeams + 1}
                            teamContext={teamName}
                        />
                        {/*<div className="py-2"/>
                        <div className="transition-all cursor-pointer rounded-full text-sky-800 font-bold py-4 px-6 text-lg bg-slate-100 hover:bg-gray-100 active:scale-95 hover:text-sky-600 hover:shadow-sm" onClick={() => setShowPlayers(false)}>Показать матчи</div>*/}
                    </ContentItem>}
                </div>
            </div>
        );
    });

    if (statItems.length === 0) {
        return null;
    }

    if (statItems.length === 1) {
        return statItems[0];
    }

    const items: TabsProps['items'] = statItems.map((item, index) => {
        return {
            key: index.toString(),
            label: statsFilters?.[index]?.title || `Турнир ${index + 1}`,
            children: item
        };
    });

    return (
        <div className="px-3 py-4">
            <Tabs defaultActiveKey={`${items.length - 1}`} items={items} centered />
        </div>
    );
}